<template>
    <div class="row align-items-md-center" :class="{ 'flex-md-row-reverse': derecha }">
        <div class="col-md-7 col-lg-8">
            <div class="lugar-interes-img" :style="`background-image: url('`+lugares[0].portada.portada+`');`">
            </div>
        </div>
        <div class="col-md-5 col-lg-4">
            <div class="lugar-interes-info">
                <div class="lugar-interes-info__encabezado">{{ lugares[0].nombre }}</div>
                <div class="lugar-interes-info__descripcion">
                    <p>{{ lugares[0].informacion_corta }}</p>
                </div>
                <a :href="lugares[0].link_mapa" target="_blank" class="link-ubicacion">¿Cómo llegar?</a>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4" v-for="(item, index) in lugares.slice(1)" :key="index">
            <div class="lugar-interes-item">
                <div class="lugar-interes-img cuadro-chico"
                :style="`background-image: url('`+item.portada.medium+`');`"></div>
                <div class="lugar-interes-info">
                    <div class="lugar-interes-info__encabezado">{{ item.nombre }}</div>
                    <div class="lugar-interes-info__descripcion">
                        <p>{{ item.informacion_corta }}</p>
                    </div>
                    <a :href="item.link_mapa" target="_blank" class="link-ubicacion">¿Cómo llegar?</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        lugares: Object,
        derecha: Boolean,
    }
}
</script>
<style>

</style>
